import React from 'react'

const Email = ({ user }) => {
    return (
        <a href={`mailto:${user.email}`}>{user.email}</a>
    )
}

export default Email